<template>
  <div>
    <the-button-back />
    <form-component />

    <button-update />
    <button-delete />
  </div>
</template>

<script>
import TheButtonBack from '@/lib/TheButtonBack'
import FormComponent from './FormComponent/index'
import ButtonUpdate from './ButtonUpdate'
import ButtonDelete from './ButtonDelete'

export default {
  components: {
    TheButtonBack,
    FormComponent,
    ButtonUpdate,
    ButtonDelete
  }
}
</script>
